import Swiper, { Navigation } from 'swiper';

export default class Slider {
	constructor(sliderElement) {
		const swiperEl = sliderElement.querySelector('[data-slider]');
		const nextButton = sliderElement.querySelector('.swiper-button-next');
		const prevButton = sliderElement.querySelector('.swiper-button-prev');

		const options = {
			direction: 'horizontal',
			slidesPerView: 1.2,
			spaceBetween: 24,
			lazy: true,
			speed: 1000,
			keyboard: true,
			modules: [Navigation],

			breakpoints: {
				576: {
					slidesPerView: 2.2,
				},
				768: {
					slidesPerView: 2.7,
					spaceBetween: 40,
				},
				1080: {
					slidesPerView: 3.2,
				},
				1400: {
					slidesPerView: 3.8,
				},
				1600: {
					slidesPerView: 4.8,
				},
			},

			a11y: {
				prevSlideMessage: 'Vorige slide',
				nextSlideMessage: 'Volgende slide',
			},

			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		};

		this.swiper = new Swiper(swiperEl, options);
	}
}
